import * as i18next from 'i18next'

export const toLanguagePath = (url: string, i18n: i18next.i18n) => `${url}?lng=${i18n.language}`
